<template>
  <section class="mod-detail-headline">
    <div class="head">
      <div class="pr-area">
        <span class="icon ribbon orange">NEW</span>
      </div>
      <div class="limit-area">
        <p class="end-date">
          掲載期間：yyyy.mm.dd～yyyy.mm.dd
        </p>
      </div>
    </div>
    <div class="title-area">
      <h1
        class="title"
        data-test="title"
      >
        {{ jobName }}
      </h1>
    </div>
    <div class="info-area">
      <p
        v-if="showSalary"
        data-test="salary-map"
      >
        <img
          class="icon-income"
          :src="`${userEndPoint}/common/sp/img/parts/icon_income.png`"
          alt="¥"
          data-test="salary-icon"
        ><span class="income">年収：{{ salaryMap.min }}～{{ salaryMap.max }}万円</span>
      </p>
      <p
        v-if="overtimeWorkHours"
        data-test="overtime-work-hours"
      >
        <img
          class="icon-overtime"
          :src="`${userEndPoint}/common/sp/img/parts/icon_overtime.png`"
          alt="残業"
          data-test="overtime-work-hours-icon"
        ><span class="overtime">目安残業時間：{{ overtimeWorkHours }}</span>
      </p>
    </div>
    <div class="pr-area">
      <div
        v-for="(employment,i) in employmentStatus"
        :key="i"
        class="icon ribbon black"
        :data-test="`employment-${i}`"
        v-text="employment"
      />
      <div
        v-if="isSimpleTypeEntryFrom"
        class="icon ribbon yellow"
        data-test="simple"
      >
        自己PR不要
      </div>
      <div
        v-if="isLightTypeEntryForm"
        class="icon ribbon yellow"
        data-test="light"
      >
        自己PRと職歴不要
      </div>
      <div
        v-if="canCasualInterview"
        class="icon ribbon yellow"
        data-test="casual-interview"
      >
        話を聞きたい応募可
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import jobPreviewVisibilityCommon from '@/lib/jobPreviewVisibilityCommon'
export default {
  mixins: [jobPreviewVisibilityCommon],
  props: {
    jobName: {
      type: String,
      required: true
    },
    employmentStatus: {
      type: Array,
      default: () => []
    },
    salaryMap: {
      type: Object,
      default: () => {}
    },
    overtimeWorkHours: {
      type: String,
      default: ''
    },
    entryFormType: {
      type: String,
      required: true
    },
    canCasualInterview: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    showSalary () {
      return this.salaryMap && this.salaryMap.min && this.salaryMap.max
    }
  }
}
</script>
